<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs4 sm3>
        <ProfileSidebar active="password" />
      </v-flex>
      <v-flex xs7 sm8 offset-xs1>
        <h1>Change Password</h1>
        <br />
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="oldPassword"
            :rules="[(v) => !!v || 'Old Password is required']"
            label="Old Password*"
            required
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            :rules="newPasswordRules"
            label="New Password*"
            required
          ></v-text-field>
          <v-text-field
            v-model="confirmNewPassword"
            @paste.prevent
            :rules="[
              newPassword === confirmNewPassword || 'Passwords must match',
            ]"
            label="Confirm New Password*"
            required
          ></v-text-field>

          <br />
          <div class="align-left">
            <v-btn
              round
              :disabled="!valid"
              color="primary"
              @click="updatePassword"
              :loading="loading"
            >
              Submit
            </v-btn>
          </div>
        </v-form>
        <v-snackbar v-model="snackbar" :color="color" bottom right>
          {{ msg }}
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import ProfileSidebar from "../../components/profile/ProfileSidebar.vue";
  import api from "../../api/datadash";
  import { mapState, mapActions } from "vuex";
  export default {
    components: {
      ProfileSidebar,
    },
    data: () => ({
      valid: false,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      newPasswordRules: [
        (v) => !!v || "New Password is required",
        (v) =>
          /(?=.{6,}).*$/.test(v) || "Password must be minimum 6 characters",
      ],
      loading: false,
      snackbar: false,
      color: "success",
      msg: "Updated successfully",
    }),
    computed: {
      ...mapState(["auth"]),
    },
    methods: {
      ...mapActions(["logout"]),
      async updatePassword() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          try {
            const { data } = await api.storeData(
              this.auth.token,
              "update-password",
              {
                old_password: this.oldPassword,
                new_password: this.newPassword,
              }
            );
            if (data.error) {
              this.color = "error";
              this.msg = data.errorMsg || "Update failed";
            } else {
              this.color = "success";
              this.msg = "Updated successfully";
              this.logout();
            }
            this.snackbar = true;
          } catch (e) {
            //
          }
          this.loading = false;
        }
      },
    },
  };
</script>
<style scoped>
  .align-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: -5px;
  }
</style>
